import { Box } from "@mui/material";
import { PinnedViewsSelector } from "./pinned_views_selector";
import { ShowSettings } from "./show_run_settings/container";
import { Download, DownloadPdf } from "./download_component";
import { SetChartView } from "./set_chart_view_component";
import { PivotControl } from "../../../constants/pivot_control_options";

export const ControlsHeader = ({
  isLoading,
  isExporting,
  showControls,
  params,
  setParams,
  datasetName,
  transformId,
  handleDownload,
  handleDownloadPdf,
  isChartView,
  setIsChartView,
  hasExpandableRows,
}: {
  isLoading: boolean;
  isExporting?: boolean;
  showControls: any[];
  params: any;
  setParams: (params: any) => void;
  datasetName: string;
  transformId: string;
  handleDownload: (excludeDetailRows: boolean) => void;
  handleDownloadPdf?: () => void | Promise<void>;
  isChartView?: boolean;
  setIsChartView?: React.Dispatch<React.SetStateAction<boolean>>;
  hasExpandableRows?: boolean;
}) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    {showControls.includes(PivotControl.StoreAsDefault) && (
      <PinnedViewsSelector
        isLoading={isLoading}
        params={params}
        setParams={setParams}
        datasetName={datasetName}
        transformId={transformId}
      />
    )}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: 34,
        border: "1px solid",
        borderColor: (t) => t.palette.atomic.border,
        borderRadius: "6px",
        overflow: "hidden",
        "&:empty": { display: "none" },
        "& .MuiIconButton-root": {
          width: 32,
          height: 32,
          margin: 0,
          borderRadius: 0,
          color: (t) => t.palette.atomic.inkSecondary,
        },
        "& > *:not(:last-child)": {
          borderRight: "1px solid",
          borderRightColor: (t) => t.palette.atomic.borderLight,
        },
      }}
    >
      {showControls.includes(PivotControl.EnableChartView) &&
        isChartView !== undefined &&
        setIsChartView && (
          <SetChartView
            isChartView={isChartView}
            setIsChartView={setIsChartView}
            isLoading={isLoading}
          />
        )}
      {showControls.includes(PivotControl.ShowSettings) && (
        <ShowSettings isLoading={isLoading} />
      )}
      {showControls.includes(PivotControl.Download) && (
        <Download
          isLoading={isLoading}
          isExporting={isExporting}
          onClick={handleDownload}
          hasExpandableRows={hasExpandableRows}
        />
      )}
      {showControls.includes(PivotControl.DownloadPdf) && handleDownloadPdf && (
        <DownloadPdf isLoading={isLoading} onClick={handleDownloadPdf} />
      )}
    </Box>
  </Box>
);
